import { create } from 'zustand'

import { AuthStore } from './types'
import { generateDPoPToken, generateKeyPair } from './utils'

export const useAuthStore = create<AuthStore>((set, get) => ({
  setAuthToken: (authToken: string) => set({ authToken }),
  generateDPoPKeys: async () => {
    const { publicJwk, privateKey } = get()
    if (publicJwk && privateKey) {
      return
    }
    const keyPair = await generateKeyPair()
    set(keyPair)
  },
  generateDPoPToken: async () => {
    const { privateKey, publicJwk } = get()
    if (!privateKey || !publicJwk) {
      return
    }
    return generateDPoPToken({ privateKey, publicJwk })
  },
}))
